module.exports = __webpack_public_path__ + "img/src/components/ContactForm/callLogo.svg?75260c96";